import React from "react";
import { useGoogleLogin } from "react-google-login";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

// styles
import styles from "./styles.module.scss";

// assets
import GoogleIcon from "src/assets/images/register/google-icon.svg";
// import AppleIcon from "src/assets/images/register/apple-icon.svg";
import FbIcon from "src/assets/images/register/fb-icon.svg";

// utils
import { keys } from "src/utils/keys";
import { LoginWithGoogle } from "../../util/network";

const SocialIcon = ({ setLoading, setUserData }) => {
  const history = useHistory();

  const { signIn } = useGoogleLogin({
    clientId: keys.google_client_id,
    onSuccess: async (res) => {
      const reponse = await LoginWithGoogle({
        googleID: res.googleId,
        email: res.profileObj.email,
        name: res.profileObj.name,
      });

      setLoading(false);

      if (reponse.data.Status) {
        setUserData(reponse.data.Results);
        history.push("/");
      } else {
        toast.error(reponse.data.ErrorMessage);
      }
    },
    onFailure: (err, detail) => {
      console.log({ err, detail });
      setLoading(false);
      toast.error(err);
    },
  });

  const handleGoogleLogin = () => {
    setLoading(true);
    signIn();
  };

  const responseFacebook = (response) => {
    console.log(response);
  };

  return (
    <div className={styles.social}>
      <div className={styles.icon__wrapper} onClick={handleGoogleLogin}>
        <img src={GoogleIcon} alt="..." />
        <span>Google</span>
      </div>
      <div className={styles.icon__wrapper}>
        {/* <img src={AppleIcon} alt="google" />
        <span>Apple</span> */}
        <FacebookLogin
          appId={keys.facebook_api_id}
          fields="name,email,picture"
          scope="public_profile,email"
          callback={responseFacebook}
          render={(renderProps) => (
            <div className={styles.icon__wrapper} onClick={renderProps.onClick}>
              <img src={FbIcon} alt="facebook" />
              <span>Facebook</span>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default SocialIcon;
